import { graphql } from "@/lib/gql/__generated__";

export const TicketListAvailable_BillingPage_Query = graphql(`
	query TicketListAvailable_BillingPage($hotelID: ID!) {
		ticketBasicListAvailable(hotelID: $hotelID) {
			id
			tickets {
				id
				hotelBasicBillingTicketID
				name
				description
				validMonth
				price {
					currencyType
					amount
				}
				isPersonal
			}
		}
		ticketProListAvailableSingleBilling(hotelID: $hotelID) {
			id
			tickets {
				id
				hotelProBillingTicketID
				name
				description
				validMonth
				price {
					currencyType
					amount
				}
				isPersonal
				saleStart
				saleEnd
			}
		}
		ticketProListAvailableContinuousBilling(hotelID: $hotelID) {
			id
			tickets {
				id
				hotelProBillingTicketID
				name
				description
				validMonth
				price {
					currencyType
					amount
				}
				isPersonal
				saleStart
				saleEnd
			}
		}
	}
`);
